module.exports = __webpack_public_path__ + "fonts/nanumbarungothicultralight-webfont.15a24e5e.woff";